(() => {
  function findPrimaryForm(main) {
    return main.querySelector('form[action*="/cart/add"]');
  }

  function injectPurchaseInfo(main) {
    if (main.querySelector('[data-phase0-purchase-info]')) return;
    const form = findPrimaryForm(main);
    if (!form) return;
    const target = form.closest('buy-buttons-block,.buy-buttons-block,.product-form-buttons,[class*="buy-buttons"]') || form;
    const info = document.createElement('div');
    info.className = 'phase0-purchase-info';
    info.dataset.phase0PurchaseInfo = 'true';
    info.innerHTML = '<p><strong>Free shipping across India</strong></p><p>Orders are processed within 1–2 business days. Delivery normally takes 5–7 business days after dispatch.</p><p>Report damaged, defective or incorrect items within 3 days of delivery.</p>';
    target.insertAdjacentElement('afterend', info);
  }

  function setupStickyCart(main) {
    const sticky = document.querySelector('[data-phase0-sticky-cart]');
    if (!sticky || sticky.dataset.phase0Ready === 'true') return;
    const button = sticky.querySelector('[data-phase0-sticky-button]');
    const price = sticky.querySelector('[data-phase0-sticky-price]');
    if (!button || !price) return;

    const sync = () => {
      const form = findPrimaryForm(main);
      const submit = form?.querySelector('button[type="submit"],input[type="submit"]');
      const currentPrice = main.querySelector('.product-details .price,.product-information .price');
      if (!submit) { sticky.hidden = true; return; }
      sticky.hidden = false;
      button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      button.textContent = button.disabled ? (submit.textContent.trim() || 'Unavailable') : 'Add to Cart';
      const text = currentPrice?.textContent.replace(/\s+/g, ' ').trim();
      if (text && text.length < 90) price.textContent = text;
    };

    button.addEventListener('click', () => {
      const submit = findPrimaryForm(main)?.querySelector('button[type="submit"],input[type="submit"]');
      if (submit && !submit.disabled) submit.click();
    });
    main.addEventListener('change', () => requestAnimationFrame(sync));
    const form = findPrimaryForm(main);
    if (form) new MutationObserver(sync).observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled','value'] });
    document.body.classList.add('phase0-product-page');
    sticky.dataset.phase0Ready = 'true';
    sync();
  }

  function init() {
    const main = document.querySelector('main[data-template^="product"]');
    if (!main) return;
    injectPurchaseInfo(main);
    setupStickyCart(main);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
